import { NgModule } from "@angular/core";
import { FieldsetModule } from 'primeng/fieldset';
import { LazyImgDirective } from "../lazy-img.directive";
import { GalleryComponent } from "../shared/gallery/gallery.component";
import { ButtonModule } from 'primeng/button';
import { ImgComponent } from "./img/img.component";

const MODULES: any[] = [
    FieldsetModule,
    ButtonModule
];
  
const DECLARATIONS: any[] = [
    LazyImgDirective,
    GalleryComponent,
    ImgComponent
];

@NgModule({
declarations: DECLARATIONS,
imports: MODULES,
exports:[...DECLARATIONS, ...MODULES]
})
export class SharedModule { }